export class CliOption {
    /**
     * @public
     * @property {string} CLI policy applied.
     * It indicates which kind of number is used as CLI
     * Detailed description of policy meanings:
     *
     *      company_policy : CLI will be the Default identifier as defined at company level (as a result it can be either the Company Number or the Work phone of the user according the chosen CLI company policy)
     *      user_ddi_number : CLI will be the Work phone of the user
     *      installation_ddi_number : CLI will be the Company number
     *      other_ddi_number : CLI will be a Hunting Group number the user belongs to. Can be also another number authorized by Admin
     *
     * Allowed values: company_policy, user_ddi_number, installation_ddi_number, other_ddi_number
     */
    policy: string;

    /**
     * @public
     * @property {string} Only when policy is "company_policy" ; it indicates what is the CLI policy defined at company level
     *
     * Allowed values: user_ddi_number, installation_ddi_number
     */
    companyPolicy?: string;

    /**
     * @public
     * @property {string} phoneNumber Unique identifier that is used for identifying selected CLI
     */
    phoneNumberId: string;

    /**
     * @public
     * @property {string} phoneNumber value that is used as CLI
     */
    number: string;

    /**
     * @public
     * @property {string} Only when CLI policy is "other_ddi_number" ; allows to differentiate Hunting Groups with another number
     *
     * Allowed values: Group, Other
     */
    type?: string;

    /**
     * @public
     * @property {string} Only when CLI policy is "other_ddi_number" and type is "Group". It is then the Group name
     */
    name?: string;

    /**
     * @public
     * @property {string} Only when CLI policy is "other_ddi_number" or "user_ddi_number". It allows to know if DDI is Main DDI or a Secondary DDI
     * Values : Main, Secondary
     */
    ddiAssignmentMode?: string;

    /**
     * @public
     * @property {boolean} Indicates if this CLI option is the Active one
     */
    current?: boolean;

    private constructor(
        policy: string,
        phoneNumberId: string,
        number: string,
        type?: string,
        companyPolicy?: string,
        name?: string,
        ddiAssignmentMode?: string,
        current?: boolean
    ) {
        this.policy = policy;
        this.companyPolicy = companyPolicy;
        this.phoneNumberId = phoneNumberId;
        this.number = number;
        this.type = type;
        this.name = name;
        this.ddiAssignmentMode = ddiAssignmentMode;//RQRAINB-11807
        this.current = current;
    }

    public static createRoutineFromData(data: any): CliOption {
        const cliOption = new CliOption(
            data.policy,
            data.phoneNumberId,
            data.number,
            data.type,
            data.companyPolicy,
            data.name,
            data.ddiAssignmentMode,
            data.current
        );
        return cliOption;
    }
}
